/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import * as browserCheck from '../../utils/browserCheck.js';
import ContactService from '../../services/contactService';
import urls from '../../constants/urls.js';
import Loading from '../common/Loading';
import ErrorMessage from '../common/ErrorMessage.js';

class Contact extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            name: props.name,
            email : props.email,
            subject: '',
            message: '',
            username: '',
            sent: false,
            error: ''
        };
        const subjectList = [];
        subjectList.push("General Query");
        subjectList.push("Problem with my account");
        subjectList.push("Suggestion");
        subjectList.push("Advertising");
        subjectList.push("Technical Issue");
        this.subjectList = subjectList;
        this.sendContact = this.sendContact.bind(this);
        this.onChange = this.onChange.bind(this);
        this.updateSubject = this.updateSubject.bind(this);
    }

    componentWillMount() {
       //this.props.actions.getActivityFeed();
    }

    componentDidMount() {
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#contactForm .getmdl-select');   
        } 
    }

    updateSubject(event) {
        const value = event.target.innerText;
        this.setState({
            subject: value
        });
    }

    sendContact(event) {
        event.preventDefault();
        ContactService.sendContact(this.state.email, this.state.name, this.state.subject, this.state.message, this.state.username)
            .then(result => {
                this.setState({
                    subject: '',
                    message: '',
                    sent: true,
                    error: ''
                });
            })
            .catch(error => {
                this.setState({
                    sent: false,
                    error: 'Sorry, we were unable to send this message at this time'
                });
            });
       
    }

    onChange(event) {
        const field = event.target.name;
        const value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    render() {
        return (
            <div className="main">
                <MetaTags>       
                    <title>Contact Us - LoudUp</title>     
                    <meta id="description" name="description" content="Send us a message with your query, issue or suggestion" />   
                </MetaTags>
                <style>{`.ui-menu-item {font-size: 0.8em;} .username { display: none;}`}</style>
                <div className="container">
                    <div className="block-inner">
                        <div className="signupbox">
                            <div className="signhead">
                                <h1 className="section-alt">Contact Us</h1>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-8 col-sm-push-2">
                                    <div id="contactUs" className="form">
                                        Have you checked out our <Link to="/FAQ">frequently asked questions</Link>? If we haven't answered your question, please feel free to contact us using the form below:
                                        <br />
                                        <br />
                                        <form id="contactForm" name="contactForm" className="form-regular form-contact" onSubmit={this.sendContact}>
                                            <ErrorMessage error={this.state.error} onClose={() => this.setState({error: null})} />
                                            {
                                                this.state.sent ? 
                                                    <div id="divSuccess" className="alert alert-success" style={{fontWeight: 'normal', display: 'block'}}>Thanks, your message has been sent and we will respond shortly!</div>
                                                : null
                                            }
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block">
                                                        <input id="name" name="name" className="mdl-textfield__input" value={this.state.name} onChange={this.onChange} required />                                                        
                                                        <label className="mdl-textfield__label" htmlFor="name">Name</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block">
                                                        <input id="email" name="email" type="email" className="mdl-textfield__input" value={this.state.email} onChange={this.onChange} required />                                                        
                                                        <label className="mdl-textfield__label" htmlFor="email">Email</label>
                                                    </div>
                                                </div>
                                            </div>                  
                                            <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select placeholder" style={{width: "100%"}}>
                                                <input className="mdl-textfield__input" type="text" id="subject" name="subject" value={this.state.subject} readOnly required />
                                                <label htmlFor="subject" className="mdl-textfield__label">Subject<span className="caret" /></label>
                                                <ul htmlFor="subject" className="mdl-menu mdl-menu--bottom-left mdl-js-menu" style={{width: "100%"}}>
                                                    {
                                                        this.subjectList.map(subject =>
                                                            <li key={subject} className="mdl-menu__item" onClick={this.updateSubject}>{subject}</li>
                                                        )
                                                    }
                                                </ul>
                                            </div>
                                            <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style={{width: "100%"}}>
                                                <textarea name="message" className="mdl-textfield__input" cols="55" value={this.state.message} onChange={this.onChange} required maxLength="500" />
                                                <label className="mdl-textfield__label" htmlFor="message">Message:</label>
                                            </div>
                                            <div className="form-group username">
                                                <label htmlFor="username">Username: </label>
                                                <input id="username" name="username" className="inputfield form-control transition" value={this.state.username} onChange={this.onChange} />                                                        
                                            </div>
                                            <div className="form-group">
                                                <input id="btnSend" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-filter" type="submit" value="SEND" name="button" />
                                            </div>  
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        );
    }
}

Contact.propTypes = {
    name: PropTypes.string,
    email: PropTypes.string
};


function mapStateToProps(state, ownProps) {
    let name = '';
    let email = '';
    if(state.account.user) {
        name = state.account.user.FirstName;
        email = state.account.user.Email;
    }
    return { name, email };
}

export default connect(mapStateToProps)(Contact);